// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import './Card.scss';
import CircleLoader from '../../../Util/CircleLoader/CircleLoader';

@inject('userStore')
@observer class Card extends Component<any, any> {

	render() {
		return (
			<div className="match">			
				{this.props.match ? 
					<div className="match-body">
						<h2>{this.props.match.participants[0].username} vs {this.props.match.participants[1].username}</h2>
						<p><b>original question:</b> {this.props.match.question.name}</p> 
					</div>
					:
					<CircleLoader size={20}/>
					}
			</div>
		)
	}
}

export default Card;

